import { createFileRoute } from "@tanstack/react-router";

// Empty index under the overview (portal's `students.overview._index`): the overview route itself
// renders the table; this only fills the index slot so no modal is shown by default.
export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/students/overview/",
)({
  component: () => null,
});
